/**
 * Helper to allow building dynamic ui-srefs
 *
 * Seems like ui-sref doesn't support any straight forward way of generating dynamic
 * declarations. This allows us to build ui-srefs that need to either have the `runs`
 * key in the middle, or not, based on the url without having to duplicate all templates.
 * It's a little strange as the ui-sref directive seems to expect a string that will be
 * executed. This also allows us to use default ui-sref-active behavior for active link
 * highlighting.
 */
export function buildViewDetailsUiSref(fragment: string, hasRunId: boolean, params: { [key: string]: any }) {
  let base = 'reportShow';
  base += hasRunId ? '.runs' : '.noRuns';
  base += fragment;

  if (params) {
    base += `(${JSON.stringify(params)})`;
  }

  return base;
}
